import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FeatureTile = ({ icon: Icon, title, description, href, accent = 'cyan', wide = false, className = '' }) => {
  const accentMap = {
    cyan: { border: 'hover:border-cyan/40', icon: 'text-cyan', bg: 'group-hover:bg-cyan/5' },
    violet: { border: 'hover:border-violet/40', icon: 'text-violet', bg: 'group-hover:bg-violet/5' },
    gold: { border: 'hover:border-gold/40', icon: 'text-gold', bg: 'group-hover:bg-gold/5' },
  };
  const a = accentMap[accent];

  return (
    <Link
      to={href}
      data-testid={`tile-${title.toLowerCase().replace(/[\s.]/g, '-')}`}
      className={`group relative border border-signal/10 rounded-lg bg-obsidian-elevated p-6 lg:p-8 transition-all duration-base ease-out-custom ${a.border} ${a.bg} ${wide ? 'col-span-2' : ''} ${className}`}
    >
      <div className="flex items-start justify-between mb-4">
        {Icon && (
          <div className={`w-10 h-10 rounded-md border border-signal/10 flex items-center justify-center ${a.icon}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
        <ArrowRight className="w-4 h-4 text-steel-muted group-hover:text-signal group-hover:translate-x-0.5 transition-all duration-fast" />
      </div>
      <h3 className="font-heading font-bold text-signal text-base mb-1">{title}</h3>
      <p className="text-steel text-sm leading-relaxed">{description}</p>
    </Link>
  );
};

export default FeatureTile;
